import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VerifyInformationService {
  id = ''
  constructor() { }

}
